import React, { useState } from 'react';

import { Grid, Typography, TextField, Box } from '@mui/material';

import '../../Helpers/print.css';

function InstallReportSignatures(props) {
  const mltsEmployee = useState(props.mltsEmployee);

  return (
    <>
      <Grid item xs={6} md={6} style={{ textAlign: 'left' }}>
        <Typography
          padding='5px'
          variant='h6'
          fontWeight='700'
          textTransform='uppercase'
        >
          This certifies that I personally checked and I am satisfied with the
          work that has been completed.
        </Typography>
      </Grid>
      <Grid item xs={6} md={6} style={{ textAlign: 'center' }}>
        <Box
          variant='h6'
          fontWeight='700'
          textTransform='uppercase'
          alignItems='center'
          sx={{
            display: 'block',
            margin: '0 auto',
            border: 'solid 2px black',
            minHeight: '180px',
            maxHeight: '180px',
            minWidth: '300px',
            maxWidth: '300px',
          }}
        >
          <Typography variant='h6' fontWeight='700' sx={{ color: 'pink' }}>
            Company Stamp
          </Typography>
        </Box>
      </Grid>

      <Grid item xs={12} md={12} style={{ textAlign: 'left' }}>
        <Typography padding='5px' variant='h6' fontWeight='700'>
          Customer Approval:
        </Typography>
      </Grid>

      <Grid
        item
        border={'grey solid 1px'}
        // xs={12}
        md={2.4}
        style={{
          textAlign: 'left',
          // borderLeft: 'none',
        }}
        sx={{ '@media print': { width: '20%' }, width: '100%' }}
      >
        <TextField
          disabled
          className='input-print-style border-bottom'
          size='small'
          fullWidth
          sx={{ '@media print': { height: '40px' } }}
        />
        <Typography
          padding='5px'
          fontWeight='700'
          sx={{ borderTop: 'black solid 2px !important' }}
        >
          Name & Surname (Customer)
        </Typography>
      </Grid>
      <Grid
        item
        border={'grey solid 1px'}
        // xs={12}
        md={2.4}
        sx={{ '@media print': { width: '20%' }, width: '100%' }}
        style={{
          textAlign: 'left',
          // borderLeft: 'none',
        }}
      >
        <TextField
          disabled
          className='input-print-style border-bottom'
          size='small'
          fullWidth
          sx={{ '@media print': { height: '40px' } }}
        />
        <Typography
          padding='5px'
          fontWeight='700'
          sx={{ borderTop: 'black solid 2px !important' }}
        >
          Customer Employee Number
        </Typography>
      </Grid>
      <Grid
        item
        border={'grey solid 1px'}
        // xs={12}
        md={2.4}
        sx={{ '@media print': { width: '20%' }, width: '100%' }}
        style={{
          textAlign: 'left',
          // borderLeft: 'none',
        }}
      >
        <TextField
          disabled
          className='input-print-style border-bottom'
          size='small'
          fullWidth
          sx={{ '@media print': { height: '40px' } }}
        />
        <Typography
          padding='5px'
          fontWeight='700'
          sx={{ borderTop: 'black solid 2px !important' }}
        >
          Signature (Customer)
        </Typography>
      </Grid>
      <Grid
        item
        border={'grey solid 1px'}
        // xs={12}
        md={2.4}
        sx={{ '@media print': { width: '20%' }, width: '100%' }}
        style={{
          textAlign: 'left',
          borderLeft: 'none',
        }}
      >
        <Typography
          padding='5px'
          fontWeight='400'
          height={40}
          borderBottom='#bdbdbd solid 1px'
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          {mltsEmployee[0]}
        </Typography>

        <Typography
          padding='5px'
          fontWeight='700'
          sx={{ borderTop: 'black solid 2px !important' }}
        >
          MLT Employee
        </Typography>
      </Grid>
      <Grid
        item
        border={'grey solid 1px'}
        // xs={12}
        md={2.4}
        sx={{ '@media print': { width: '20%' }, width: '100%' }}
        style={{
          textAlign: 'left',
          borderLeft: 'none',
        }}
      >
        <TextField
          disabled
          className='input-print-style border-bottom'
          size='small'
          fullWidth
          sx={{ '@media print': { height: '40px' } }}
        />
        <Typography
          padding='5px'
          fontWeight='700'
          sx={{ borderTop: 'black solid 2px !important' }}
        >
          MLT Employee Signature
        </Typography>
      </Grid>
      <Grid
        item
        border={'none'}
        xs={12}
        md={12}
        style={{
          textAlign: 'center',
          borderLeft: 'none',
        }}
      >
        <Typography
          padding='5px'
          fontWeight='300'
          // sx={{ borderTop: 'black solid 2px !important' }}
        >
          Multilayer Trading 867 (Pty) Ltd, Reg. No. 2015/313443/07, The Grove
          Business Estate, Unit B11,
        </Typography>
      </Grid>
      <Grid
        item
        border={'none'}
        xs={12}
        md={12}
        style={{
          textAlign: 'center',
          borderLeft: 'none',
        }}
      >
        <Typography
          padding='5px'
          fontWeight='300'
          // sx={{ borderTop: 'black solid 2px !important' }}
        >
          Ou Paardevlei Rd, The Interchange, Somerset West, 7130
        </Typography>
      </Grid>
      <Grid
        item
        border={'none'}
        xs={12}
        md={12}
        style={{
          textAlign: 'center',
          borderLeft: 'none',
        }}
      >
        <Typography
          padding='5px'
          fontWeight='300'
          // sx={{ borderTop: 'black solid 2px !important' }}
        >
          Tel Office: +27 (0) 851-9616, Tel Helpdesk: +27 (0) 64 903 5070
        </Typography>
      </Grid>
      <Grid
        item
        border={'none'}
        xs={12}
        md={12}
        style={{
          textAlign: 'center',
          borderLeft: 'none',
        }}
      >
        <Typography padding='5px' fontWeight='300'>
          E-mail: thedo@ahtafrica.co.za, jennifer@ahtafrica.co.za,
          helpdesk@ahtafrica.co.za
        </Typography>
      </Grid>
    </>
  );
}

export default InstallReportSignatures;
